<template>
  <transition name="fade">
    <div v-if="internalValue" id="applicant-edit-tab-job">
      <VacancyStat
        v-if="
          internalValue.number && $store.getters['user/hasPermission']('bi')
        "
        :number="internalValue.number"
      ></VacancyStat>

      <div class="job-edit-menu p-3">
        <ul>
          <li>
            <a
              v-smooth-scroll="{ offset: -50 }"
              href="#jobAllgemein"
              class="lg:text-xl font-medium text-gray-600"
              >Allgemein</a
            >
          </li>
          <li>
            <a
              v-smooth-scroll="{ offset: -50 }"
              href="#jobEinstellungen"
              class="lg:text-xl font-medium text-gray-600"
              >Stellen Einstellungen</a
            >
          </li>
          <li>
            <a
              v-smooth-scroll="{ offset: -50 }"
              href="#jobBeschreibung"
              class="lg:text-xl font-medium text-gray-600"
              >Stellen Beschreibung</a
            >
          </li>
          <li>
            <a
              v-smooth-scroll="{ offset: -50 }"
              href="#website"
              class="lg:text-xl font-medium text-gray-600"
              >Webseite</a
            >
          </li>
          <li>
            <a
              v-smooth-scroll="{ offset: -50 }"
              href="#applicant-table"
              class="lg:text-xl font-medium text-gray-600"
              >Bewerber</a
            >
          </li>
          <li v-if="$store.getters['user/hasPermission']('bi')">
            <a
              v-smooth-scroll="{ offset: -50 }"
              href="#qrcode"
              class="lg:text-xl font-medium text-gray-600"
              >Qr-Code</a
            >
          </li>
        </ul>
      </div>
      <ValidationObserver ref="jobEdit" tag="form">
        <JobGeneralForm
          v-model="internalValue"
          :project-consultant-i-d="projectConsultantID"
          @preventUpdate="x => (preventUpdate = x)"
          @updated="() => $apollo.queries.vacancy.refetch()"
        />
      </ValidationObserver>
      <!-- additionalServices -->
      <div class="p-3">
        <vs-button @click="saveData()">Speichern</vs-button>
      </div>
      <div id="applicant-table">
        <job-applicant-table :vacancy-i-d="vacancy.id" />
      </div>
      <div v-if="vacancy && $store.getters['user/hasPermission']('bi')">
        <QrCodes :vacancy="vacancy" />
      </div>
    </div>
  </transition>
</template>

<script>
import gql from "graphql-tag";
import jobVariants from "@/data/enums/JobVariant.js";
import editFormMixin from "@/mixins/editFormMixin.js";
import JobGeneralForm from "../form/JobGeneral";
import VacancyStat from "../stats/VacancyStat";
import JobApplicantTable from "../../../components/job/JobApplicantTable.vue";
import QrCodes from "@/components/job/JobQrCodes";

export default {
  components: {
    VacancyStat,
    JobGeneralForm,
    JobApplicantTable,
    QrCodes
  },
  mixins: [
    editFormMixin({
      idFields: [
        "vamOccupation",
        "vamExportError",
        "occupationBenefit",
        "language"
      ],
      legacyIDFields: ["jobTimes"],
      ignoredFields: ["number", "createdAt"]
    })
  ],
  props: {
    projectId: { type: String, required: true },
    projectConsultantID: { type: String, required: false }
  },
  data() {
    return {
      jobVariants,
      fetchFailed: false,
      currentPage: 0,
      accordionOpen: [],
      createData: null,
      currentlySaving: false,
      preventUpdate: false
    };
  },
  apollo: {
    vacancy: {
      query: gql`
        query Vacancy($id: ID!) {
          vacancy(id: $id) {
            publicationSchedule {
              errors
              newActiveFrom
              newActiveUntil
              processed
              remainingTries
            }
            language {
              id
            }
            languageID
            isInternational
            id
            number
            title
            companyProfileText
            activeFrom
            activeUntil
            workPlace
            createdAt
            project {
              id
              userGroup {
                id
              }
              skillJobType {
                id
              }
            }
            jobType {
              id
              name
            }
            active
            internalInfo
            recruitment
            allowOnlineApplication
            adCampaignBudget {
              googleAdsBudget
              facebookAdInsightBudget
            }
            advertisingBudgetNotes
            companyLogoID
            occupationCategory {
              id
              name
            }
            occupationBenefit {
              id
              name
            }
            jobActivitiesText
            jobProfilesText
            jobPerspectiveText
            jobInfosText
            jobCustomerDetailsText
            jobFooterText
            topjob
            topjobDate
            holidayAndChristmasBonus
            additionalServices
            jobEarningLegacy
            takeoverOption
            jobHoursLegacy
            vamExport
            vamTitle
            vamOccupation {
              id
              name
            }
            vamJobOfferType
            vamEducationAuthorization
            vamSocialInsurance
            vamExportError
            publication {
              id
              rePublishFrom
              rePublishUntil
              rePublishAmount
              rePublishInterval
            }
            address {
              street
              country
              zip
              city
              lat
              lng
            }
            jobTimes {
              id
              name
            }
            jobVariant
            jobTemplateID
            contactType
            contactID
            contactEmail
            samPostID
            indeedPremium
          }
        }
      `,
      skip() {
        return (
          !this.$route.params.jobid ||
          this.$route.params.jobid === "create" ||
          this.preventUpdate
        );
      },
      result(data) {
        if (
          data.data.vacancy.adCampaignBudget.googleAdsBudget != null ||
          data.data.vacancy.adCampaignBudget.facebookAdInsightBudget != null
        ) {
          data.data.vacancy.adCampaignBudget.enabled = true;
        }
        // sort by date time
        if (data.data.vacancy.publicationSchedule) {
          data.data.vacancy.publicationSchedule.sort(function(a, b) {
            var c = new Date(a.new_active_from);
            var d = new Date(b.new_active_until);
            return c - d;
          });
        }

        this.updateCurrent();
      },
      variables() {
        return {
          id: this.$route.params.jobid
        };
      },
      fetchPolicy: "network-only"
    }
  },
  computed: {
    internalValue: {
      get() {
        return (this.createData && this.$route.params.jobid === "create") ||
          !this.vacancy
          ? this.createData
          : this.vacancy;
      },
      set(v) {
        if (this.$route.params.jobid === "create") {
          this.createData = v;
        } else {
          this.save(false);
        }
      }
    }
  },
  watch: {
    "$route.params.jobid": {
      immediate: true,
      handler(v) {
        if (v === "create") {
          this.createData = {
            vamSocialInsurance: true,
            adCampaignBudget: {
              enabled: true,
              googleAdsBudget: 280,
              facebookAdInsightBudget: 800
            }
          };
        } else {
          this.createData = null;
        }
      }
    },
    internalValue: {
      deep: true,
      handler: function(v) {
        this.internalValue = v;
      }
    }
  },
  methods: {
    async saveData() {
      if (this.$route.params.jobid === "create") {
        return await this.persist();
      }

      return await this.save();
    },
    async persist() {
      if (this.$route.params.jobid === "create") {
        let adCampaignBudget = this.createData.adCampaignBudget;
        delete this.createData.adCampaignBudget;
        let updateAdCampiagnBudget = true;
        if (!adCampaignBudget.enabled) {
          updateAdCampiagnBudget = false;
        }
        delete adCampaignBudget.enabled;
        await this.$apollo
          .mutate({
            mutation: gql`
              mutation($input: CreateVacancyInput!, $project: ID!) {
                vacancyCreate(projectId: $project, input: $input) {
                  id
                }
              }
            `,
            variables: {
              input: Object.prepareGqlInput(this.createData, [], ["createdAt"]),
              project: this.projectId
            }
          })
          .then(async ({ data }) => {
            const jobid = data.vacancyCreate.id;

            if (!jobid) {
              // TODO: Handle error
              return;
            }

            if (
              updateAdCampiagnBudget &&
              this.$store.getters["user/hasPermission"]("ad_campaigns")
            ) {
              await this.$apollo.mutate({
                mutation: gql`
                  mutation AdvertiseVacancy($input: AdCampaignBudgetInput!) {
                    advertiseVacancy(input: $input) {
                      id
                    }
                  }
                `,
                variables: {
                  input: {
                    title: this.createData.title,
                    vacancyId: jobid,
                    ...adCampaignBudget
                  }
                }
              });
            }

            this.$router.push({
              name: "project.edit.sub.job",
              params: { page: "jobs", jobid }
            });
          });
      } else {
        if (this.currentlySaving) {
          return;
        } else {
          this.currentlySaving = true;
        }
        try {
          while (this.$apollo.loading) {
            await new Promise(resolve => setTimeout(resolve, 100));
          }
          let result = await this.$refs.jobEdit.validate();
          if (result) {
            let input = this.getInput();
            delete input.project;
            if (input.publication) {
              input.publication = Object.prepareGqlInput(
                input.publication,
                [],
                ["rePublishFrom"]
              );
            }

            delete input.publicationSchedule; // MUST!

            if (input.jobType && typeof input.jobType == "object") {
              input.jobType = input.jobType.id;
            }
            if (
              input.occupationCategory &&
              typeof input.occupationCategory == "object"
            ) {
              input.occupationCategory = input.occupationCategory.id;
            }
            try {
              if (!input.adCampaignBudget.enabled) {
                input.adCampaignBudget.googleAdsBudget = null;
                input.adCampaignBudget.facebookAdInsightBudget = null;
              }
              delete input.adCampaignBudget.enabled;
              let adCampaignBudget = input.adCampaignBudget;
              delete input.adCampaignBudget;

              await this.$apollo.mutate({
                mutation: gql`
                  mutation($id: ID!, $input: VacancyInput!) {
                    vacancyUpdate(id: $id, input: $input) {
                      id
                    }
                  }
                `,
                variables: {
                  id: this.internalValue.id || this.$route.params.jobid,
                  input
                }
              });

              if (this.$store.getters["user/hasPermission"]("ad_campaigns")) {
                await this.$apollo.mutate({
                  mutation: gql`
                    mutation AdvertiseVacancy($input: AdCampaignBudgetInput!) {
                      advertiseVacancy(input: $input) {
                        id
                      }
                    }
                  `,
                  variables: {
                    input: {
                      title: input.title,
                      vacancyId:
                        this.internalValue.id || this.$route.params.jobid,
                      ...adCampaignBudget
                    }
                  }
                });
              }

              this.reportSuccess(input);
            } catch (e) {
              this.reportUnhandledError(e);
            }
          } else {
            this.$vs.notify({
              title: "Fehlgeschlagen",
              text: "Eingabe ist fehlgeschlagen.",
              color: "danger",
              icon: "query_builder",
              position: "bottom-center"
            });
            //document.documentElement.scrollTop = 0;
          }
        } catch (e) {
          this.currentlySaving = false;
          throw e;
        }
        this.currentlySaving = false;
      }
    }
  }
};
</script>
